var _excluded = ["component", "name", "id", "value", "label", "hint", "checked", "disabled", "className", "onChange", "onBlur"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from 'react';
import { Flex } from '@creditas-ui/layout';
import { InputRadio } from './InputRadio';
import { RadioElements, InputLabel, InputHint } from './Radio.style';
var Radio = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'input' : _ref$component,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? '' : _ref$id,
      value = _ref.value,
      label = _ref.label,
      hint = _ref.hint,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      className = _ref.className,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(InputRadio, _extends({}, props, {
    as: component,
    name: name,
    id: id,
    value: value,
    checked: checked,
    disabled: disabled,
    className: className,
    onChange: onChange,
    onBlur: onBlur,
    ref: ref
  })), /*#__PURE__*/React.createElement(RadioElements, null, label && /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: id,
    active: checked,
    disabled: disabled
  }, label), hint && /*#__PURE__*/React.createElement(InputHint, null, hint)));
});
export { Radio };